export default () => ({
    height: 'calc(100% - 7rem)',
    overflow: 'auto',
});
